import React from 'react';

/**
 * Generic page header used by list screens (tenders, clients, brands, products, etc.).
 *
 * Props:
 * - title: string (required)
 * - subtitle: string (optional)
 * - actions: React node (optional) – usually buttons / right‑side content
 * - className: optional extra class for container (e.g. 'tender-list-header')
 */
function PageHeader({ title, subtitle, actions, className = '' }) {
  return (
    <div className={`page-header ${className}`.trim()}>
      <div className="header-title">
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && (
        <div className="header-actions">
          {actions}
        </div>
      )}
    </div>
  );
}

export default PageHeader;

